import axios from 'axios';
import {checkErrors} from './errors';

export const LOADTAGS_REQUESTED = 'tags/LOADTAGS_REQUESTED';
export const LOADTAGS_FINISHED = 'tags/LOADTAGS_FINISHED';
export const SETTAGS = 'tags/SETTAGS';

const initialState = {
  tags: [],
  total: 0,
  limit: 1000,
  skip: 0,
  isLoadingTags: false
};

export default (state = initialState, action) => {
  switch (action.type) {
  case LOADTAGS_REQUESTED:
    return {
      ...state,
      isLoadingTags: true
    };

  case LOADTAGS_FINISHED:
    return {
      ...state,
      isLoadingTags: false
    };

  case SETTAGS:
    
    return {
      ...state,
      tags: action.tags
    };
  
  default:
    return state;
  }
};


export const loadTags = () => {
  return (dispatch, getState) => {

    const tagsState = getState().tags;

    dispatch({
      type: LOADTAGS_REQUESTED
    });

    axios.get(`${window.endpoint}/tags?limit=${tagsState.limit}&skip=${tagsState.skip}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: SETTAGS,
        tags: response.data.tags
      });

      dispatch({
        type: LOADTAGS_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags.js